import React, {useState} from 'react';
import type {ActionButtonProps} from './types';
import {AreYouSureDialog} from '../dialog';
import {ActionButton} from './ActionButton';

export const ConfirmButtonV2: React.FC<
  ActionButtonProps & {
    doubleConfirm?: boolean;
    doubleConfirmMessage?: string;
    prevent?: string;
  }
> = ({
  title,
  onClick,
  doubleConfirm,
  doubleConfirmMessage,
  prevent,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenConfirmation = () => {
    setOpen(true);
  };

  const handleCloseConfirmation = (confirmed?: boolean) => {
    setOpen(false);

    if (confirmed) {
      onClick();
    }
  };

  return (
    <>
      <ActionButton
        showSpinnerOnClick
        onClick={handleOpenConfirmation}
        title={title}
        {...props}
      />

      <AreYouSureDialog
        id="confirm-dialog"
        keepMounted={false}
        open={open}
        onClose={handleCloseConfirmation}
        doubleConfirm={doubleConfirm}
        doubleConfirmMessage={doubleConfirmMessage}
        prevent={prevent}
      />
    </>
  );
};
